import React from 'react'
import { Routes, Route  } from 'react-router-dom'

// Import all page components
import AuthenticationFailed from './Pages/AuthenticationFailed'
import ForgotPassword from './Pages/ForgotPassword'
import NotFound from './Pages/NotFound'
import PunchIn from './Pages/PunchIn'
import ResetPassword from './Pages/ResetPassword'
import SignInCapture from './Pages/SignInCapture'
import SignInForm from './Pages/SignInForm'
import TwoFactorForm from './Pages/TwoFactorForm'
import SignUpConfirm from './Pages/SignUpConfirm'
import SignUpForm from './Pages/SignUpForm'
import RegisterInterestXeroForm from './Pages/RegisterInterestXeroForm/RegisterInterestXeroForm'

const AppRoutes = () => {
  return (
    <Routes>
      {/* Register */}
      <Route path="/register" element={<SignUpForm />} />
      <Route path="/register/confirm" element={<SignUpConfirm />} />
      <Route path="/register/:partnerId" element={<SignUpForm />} />
      <Route path="/register/interest/xero" element={<RegisterInterestXeroForm />} />

      {/* Forgotten Password */}
      <Route path="/forgottenPassword" element={<ForgotPassword />} />
      <Route path="/forgottenPassword/:partnerId" element={<ForgotPassword />} />

      {/* Reset Password */}
      <Route path="/resetforgottenpassword/:tenantId/:resetId" element={<ResetPassword />} />
      <Route
        path="/resetforgottenpassword/:partnerId/:tenantId/:resetId"
        element={<ResetPassword />}
      />

      {/* Login */}
      <Route path="/login" element={<SignInForm />} />
      <Route path="/login/capture-external" element={<SignInCapture />} />
      <Route path="/login/:partnerId" element={<SignInForm />} />
      <Route path="/login/two-factor" element={<TwoFactorForm />} />
      <Route path="/login/two-factor/:partnerId" element={<TwoFactorForm />} />
      <Route path="/" element={<SignInForm />} />
      <Route path="/two-factor" element={<TwoFactorForm />} />

      {/* PunchIn */}
      <Route path="/punchin/:tenantId/:transactionId" element={<PunchIn />} />

      {/* Auth & NotFound */}
      <Route path="/auth-failed" element={<AuthenticationFailed />} />
      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes